
import collect from 'collect.js'
import Clock from '@/assets/icons/fontawesome/duotone/clock.svg?inline'

export default {
  components: {
    Clock,
  },
  props: {
    time: {
      type: Number,
      default: 0,
    },
    hotel: {
      type: Object,
      default: null,
    },
    search: {
      type: Object,
      default: null,
    },
    shouldShowTimer: {
      type: Boolean,
      default: true,
    },
    newSite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      counting: true,
      modalRefeshResult: false,
    }
  },
  computed: {
    path() {
      if (!this.hotel) {
        return null
      }
      if (this.newSite) {
        const q = { ...this.query }
        delete q.currency
        return this.$config.newFlightsDomain +
          (this.$i18n.locale === 'he' ? '/he' : '') +
          '/hotels/place/' +
          this.hotel.country.slug + '/' + this.hotel.slug + '?' + new URLSearchParams(q).toString()
      }
      if (this.hotel.aggregator === 'innstant') {
        return this.localePath({
          name: 'hotels-destination-countrySlug-destinationSlug-hotelSlug',
          params: {
            countrySlug: this.hotel.destinations[0].country.slug,
            destinationSlug: this.hotel.destinations[0].slug,
            hotelSlug: this.hotel.slug,
          },
          query: this.query,
        })
      } else {
        return this.localePath({
          name: 'hotels-place-countrySlug-hotelId',
          params: {
            countrySlug: this.hotel.country.slug,
            hotelId: this.hotel.id,
          },
          query: this.query,
        })
      }
    },
    query() {
      return collect(this.search)
        .only([
          'check_in',
          'check_out',
          'guests',
          'country',
          'currency',
          'radius',
          'latitude',
          'longitude',
        ])
        .all()
    },
  },
  watch: {
    time: {
      handler(value) {
        if (value === 0) {
          this.handleCountdownEnd()
        }
      },
    },
  },
  mounted() {
    if (this.time <= 0) {
      this.$nextTick(() => {
        this.refresh()
      })
    }
  },
  methods: {
    refresh() {
      if (!this.search && !this.hotel) {
        window.location = window.location.href.split('session')[0]
      } else {
        window.location = this.path
      }
    },

    handleCountdownEnd() {
      this.$emit('timer-expired')
      this.counting = false
      this.modalRefeshResult = true
    },
  },
}
